import React, { useState, useEffect, useContext } from "react";

// Packages import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Paper,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Avatar,
  Grid,
  IconButton,
  Stack,
  Modal,
  Tooltip,
} from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Search as SearchIcon, Title } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  Logout as LogoutIcon,
  SignalWifiStatusbarNullTwoTone,
} from "@mui/icons-material";

// User Import

import DelModal from "./DelModal";
import { RoutesUrls, ministryRoutes } from "../../../Services/Routes/APP";
import { headersPost } from "../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../Services/Routes/API";
import { getPagination } from "../../../common/functions";
import { ministry_Context } from "../../../context";
import { DetailsIcon, EditIcon1, Active, Inactive, Users } from "../../../Svg";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

// constants

const headings = [
  "Name",
  "Population",
  "Cities",
  "Population Served",
  "Actions",
];
const usersHeading = ["Name", "Email", " Status", "Actions"];

//component

const Province = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  //states

  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(1);
  const [provinces, setProvinces] = useState([]);
  const [product, setProduct] = useState(null);
  const [product2, setProduct2] = useState(null);

  const [usersModal, setUsersModal] = useState("");

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [api, setApi] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredStates, setFilteredState] = useState([]);
  const [states, setStates] = useState([]);
  const [searched, setSearched] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [usersModalOpen, setUsersModalOpen] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [searchData, setSearchData] = useState("");

  const openn = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //menu close handler

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const logoutHandler = () => {
    localStorage.clear();
    navigate(RoutesUrls?.root);
  };
  // constant

  const addHandler = () => {
    navigate(RoutesUrls.ministryAdmin + ministryRoutes.addProvince);
  };
  const editHandler = (row) => {
    navigate(RoutesUrls.ministryAdmin + ministryRoutes.editProvince, {
      state: {
        node: row,
      },
    });
  };
  const detailhandler = (row) => {
    navigate(RoutesUrls.ministryAdmin + ministryRoutes.detailsProvince, {
      state: {
        node: row,
      },
    });
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const delProduct = (pro) => {
    setProduct(pro);
    setOpenModal(true);
  };

  const delProduct2 = (pro, users_modal) => {
    setProduct2(pro);
    setUsersModal(users_modal);
    setOpenModal(true);
  };

  //get Provinces

  const getProvinces = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(MINISTRY_API_ULRS.GET_ALL_PROVINCE, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setStates(res?.data?.states);
          setFilteredState(res?.data?.states);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //life cycle

  useEffect(() => {
    getProvinces();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(!api);
  };

  const provinceDelHandler = () => {
    const data = {
      state: {
        id: product?.id,
        is_active: product?.is_active ? false : true,
      },
    };
    setOpen(true);
    headersPost(MINISTRY_API_ULRS?.UPDATE_PROVINCE, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
    setOpenModal(false);
  };

  const provinceDelHandler2 = () => {
    const data2 = {
      user: {
        id: product2?.id,
        is_active: product2?.is_active ? false : true,
      },
    };

    setOpen(true);

    headersPost(MINISTRY_API_ULRS?.UPDATE_USERS, data2)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          const { data } = res;
          const { user } = data;
          const { id: userId } = user;
          setUsersList((prev) =>
            prev?.map((users) => {
              const { id } = users;
              if (id === userId) {
                return user;
              }
              return users;
            })
          );
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
    setOpenModal(false);
  };

  const requestSearch = (searchedVal) => {
    const filteredRows = states.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setFilteredState(filteredRows);
  };

  // user modal handlers

  const usersHandler = (users) => {
    setUsersList(users);
    setUsersModalOpen(true);
  };

  const usersHandlerClose = () => {
    setUsersModalOpen(false);
    setUsersList([]);
  };
  // render

  return (
    <Box>
      {/* <Paper elevation={1} borderRadius={1}>
        <Grid container>
          <Grid
            item
            xs={8}
            sm={8}
            md={8}
            lg={8}
            sx={{ p: 1 }}
            alignItems={"center"}
          >
            <Typography
              variant="h5"
              m={0.5}
              sx={{
                fontWeight: "bold",
                color: theme.palette.text.light,
                marginTop: theme.spacing(1.5),
                marginLeft: theme.spacing(2),
              }}
            >
              {user?.name}
            </Typography>
            <Typography variant="h5" color={"text.grayText"} ml={2} mt={1.5}>
              Provinces
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            lg={4}
            display={"flex"}
            justifyContent={"flex-end"}
          >
            <Box mr={2} display={"flex"} alignItems={"center"}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={addHandler}
                sx={{
                  minHeight: 40,
                  minWidth: 120,
                  minWidth: 150,
                  display: { xs: `none`, sm: "flex" },
                }}
                startIcon={<AddIcon />}
              >
                Add Node Manually
              </Button>
            </Box>
            <Typography
              mt={3}
              sx={{
                textTransform: "capitalize",
              }}
            >
              {user?.name}
            </Typography>
            <Box m={1} component={IconButton} onClick={handleClick}>
              <Avatar
                sx={{ width: "40px", height: "40px" }}
                src="/images/Australia.png"
              ></Avatar>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={openn}
              onClose={handleClose2}
              onClick={handleClose2}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={logoutHandler}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={addHandler}
                display={{ xs: "flex", sm: "none" }}
              >
                <ListItemIcon>
                  <UploadFileIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText> Add Node Manually</ListItemText>
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Paper> */}
      {/* <Box
        display={{ md: "flex", sm: "flex" }}
        justifyContent={{ md: "space-between", sm: "space-between" }}
      >
        <Box paddingBottom={{ xs: 2 }}>
          <Typography
            color={"text.grayText"}
            sx={{
              textTransform: "uppercase",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={"bold"}
              component={"span"}
              sx={
                {
                  // borderBottom: `1px solid ${theme.palette.text.secondary}`,
                }
              }
            >
              {user?.name}
            </Typography>
          </Typography>
          <Typography
            variant="h6"
            fontWeight={"bold"}
            color={"text.lightGray"}
            sx={{
              paddingBottom: { xs: 0, sm: 1, md: 2 },
              borderBottom: `1px solid ${theme.palette.text.secondary}`,
            }}
          >
            Provinces
          </Typography>
        </Box>
        <Box display={{ xs: "flex" }} justifyContent={{ xs: "right" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              onClick={addHandler}
              sx={{
                borderRadius: 2,
                maxHeight: 40,
              }}
            >
              Upload Node
            </Button>
          </Stack>
        </Box>
      </Box> */}

      <Box
        marginTop={2}
        mb={2}
        mr={2}
        display={"flex"}
        justifyContent={"flex-end"}
      >
        <TextField
          size="small"
          type="search"
          placeholder="Search by name"
          value={searched}
          onChange={(e) => {
            setSearched(e.target.value);
            requestSearch(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <SearchIcon
                sx={{
                  color: theme.palette.primary.dark,
                }}
              />
            ),
          }}
          sx={{
            borderRadius: 25,
            backgroundColor: theme.palette.secondary.dark,
            [`.${outlinedInputClasses.root}`]: {
              borderRadius: 25,
              paddingX: 2,
            },
          }}
        ></TextField>
      </Box>
      <Box>
        <Paper elevation={1}>
          <TableContainer>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredStates?.length > 0 ? (
                  filteredStates?.map((row, index) => (
                    <TableRow
                      // key={row.name}
                      key={`${index}-row.name-${index + 2}`}
                    >
                      <TableCell align="center"   wordWrap="break-word"
>{row?.name}</TableCell>
                      <TableCell align="center">{row?.population}</TableCell>
                      <TableCell align="center">{row?.districts}</TableCell>
                      <TableCell align="center">
                        {row?.vaccinated || 0}
                      </TableCell>

                      <TableCell>
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Tooltip title="Actions">
                            <Button
                              variant="contained"
                              onClick={() => delProduct(row)}
                              size="small"
                              sx={{
                                padding: 0,
                                borderRadius: 4,
                              }}
                            >
                              {row?.is_active ? <Inactive /> : <Active />}
                            </Button>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              onClick={() => editHandler(row)}
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,
                                padding: 1,
                              }}
                            >
                              <EditIcon1 />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Details">
                            <Button
                              color="secondary"
                              variant="contained"
                              onClick={() => detailhandler(row)}
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,
                                paddingX: 1,
                              }}
                            >
                              <DetailsIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Users">
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => usersHandler(row?.users)}
                              sx={{
                                borderRadius: 1,

                                minWidth: 2,

                                paddingX: 1,
                              }}
                            >
                              <Users />
                            </Button>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    {" "}
                    <TableCell colSpan={5}>
                      {" "}
                      <Typography
                        variant="body1"
                        width={"100%"}
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        No Data Found
                      </Typography>{" "}
                    </TableCell>{" "}
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
              <Pagination
                count={totalCount > 10 ? getPagination(totalCount) : 1}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </Box>
          </TableContainer>
        </Paper>
      </Box>

      <DelModal
        status={product?.is_active}
        status2={product2?.is_active}
        open={openModal}
        handleClose={closeModalHandler}
        provinceDelHandler={provinceDelHandler}
        provinceDelHandler2={provinceDelHandler2}
        usersModal={usersModal}
      />
      <Modal
        open={usersModalOpen}
        onClose={usersHandlerClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            minWidth: "50%",
            maxWidth: "90%",
            maxHeight: "80%",
            minHeight: "70%",
            boxShadow: 24,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box p={2}>
            <Typography
              display={"flex"}
              justifyContent={"left"}
              pl={1}
              variant="h6"
              component="h2"
              sx={{ color: theme.palette.text.light, fontWeight: "bold" }}
            >
              Users
            </Typography>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {usersHeading?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {usersList?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell
                      align="center"
                      sx={{
                        wordWrap: "break-word"
                      }}
                    >
                      {row?.name}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        maxWidth: { xs: "80px", sm: "140px", md: "300" },
                        wordWrap: "break-word",
                      }}
                    >
                      {row?.email}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={row?.is_active ? "Not verified" : "Verified"}
                        sx={{
                          backgroundColor: row?.is_active
                            ? `${theme.palette.error.light}`
                            : `${theme.palette.success.light}`,

                          borderRadius: 2,
                          color: row?.is_active
                            ? `${theme.palette.error.main}`
                            : `${theme.palette.success.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Button
                          variant="contained"
                          onClick={() => delProduct2(row, "users_modal")}
                          size="small"
                          sx={{
                            padding: 0,
                            borderRadius: 4,
                          }}
                        >
                          {row?.is_active ? <Inactive /> : <Active />}
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Province;
